import type { TeamMonitoring } from '../../services/homeStats';
import type { PieSlice } from '../monitoring/overview/OverviewDonut';
import { CATEGORY_LEGEND } from '../monitoring/overview/overviewLegend';
import { PieBlock } from './TeamWorkloadCard';

const MONITORING_OVERVIEW_PATH = '/monitoring/overview';

function monitoringSlices({ notifications, messages }: TeamMonitoring): PieSlice[] {
    return [
        {
            key: 'notifications',
            count: notifications,
            ...CATEGORY_LEGEND.notification,
            fill: 'fill-[#007E87]'
        },
        { key: 'messages', count: messages, ...CATEGORY_LEGEND.message, fill: 'fill-teal-200' }
    ];
}

export function TeamMonitoringPie({ monitoring }: { monitoring: TeamMonitoring }) {
    return (
        <PieBlock
            title="Monitoring"
            href={MONITORING_OVERVIEW_PATH}
            slices={monitoringSlices(monitoring)}
            emptyText="No open monitoring items."
        />
    );
}
